import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  quote: string;
  product?: string;
}
export function TestimonialCard({
  initials,
  name,
  location,
  quote,
  product
}: TestimonialProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="bg-brand-black border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col h-full hover:border-brand-green/30 transition-colors" data-id="element-243" data-mp="3azjdnwexoibo">
      <div className="flex items-center gap-4 mb-6" data-id="element-244" data-mp="2x2w50wdmc3px">
        <div className="w-12 h-12 rounded-full bg-brand-dark border border-brand-green/30 flex items-center justify-center text-brand-light font-bold text-lg" data-id="element-245" data-mp="2s2rx3uqs0hbb">
          {initials}
        </div>
        <div data-id="element-246" data-mp="qa3qdbexbbqs">
          <div className="font-bold text-white" data-id="element-247" data-mp="qbn7f48elqtm">{name}</div>
          <div className="text-sm text-gray-400" data-id="element-248" data-mp="h67x3xu3nc77">{location}</div>
        </div>
      </div>

      <div className="flex gap-1 mb-4" data-id="element-249" data-mp="m51ew2gf5pd6">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-brand-gold fill-brand-gold" data-id="element-250" data-mp="m2ygov544pxd" data-mpi={i} />)}
      </div>

      <p className="text-gray-300 italic flex-grow" data-id="element-251" data-mp="79v3t12gv0cz">"{quote}"</p>

      {product && <div className="mt-6 pt-4 border-t border-gray-800 text-xs text-brand-light font-medium" data-id="element-252" data-mp="c73nj639jcgc">
          Compró: {product}
        </div>}
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mirta G.',
    location: 'Buenos Aires',
    quote: 'Llevaba 6 años con la panza inflada. A los 10 días del sistema me desperté liviana por primera vez en años.'
  }, {
    initials: 'CS',
    name: 'Carmen S.',
    location: 'Córdoba',
    quote: 'Por fin una guía que me dice exactamente dónde comprar en Argentina. Todo lo conseguí en el Coto de mi barrio.'
  }, {
    initials: 'ER',
    name: 'Elena R.',
    location: 'Rosario',
    quote: 'El Planner de 21 días fue lo que me faltaba. Dejé de improvisar y mi digestión finalmente respondió.'
  }];
  return <section className="py-20 bg-brand-dark" data-id="element-253" data-mp="1ojf7vnz8ax23">
      <div className="container mx-auto px-4" data-id="element-254" data-mp="1jj10871jhp4l">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-255" data-mp="1jkc384n5usun">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-256" data-mp="19ser8vobvwuv" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}